export default __webpack_public_path__ + "static/media/red-missed-checkmark.9469dc25.svg";